import script from "./DreiVergleich.vue?vue&type=script&setup=true&lang=js"
export * from "./DreiVergleich.vue?vue&type=script&setup=true&lang=js"

import "./DreiVergleich.vue?vue&type=style&index=0&id=5b64d0fa&lang=css"

const __exports__ = script;

export default __exports__